module.exports = __webpack_public_path__ + "img/dsci0115.2671281b.jpg";